import React from 'react';
import {Button, Modal, Table} from "antd";
import {connect} from "react-redux";
import {
    loadCompanyWebhookLogs
} from "../../actions/account";
import {displayErrors} from "../../libs/utils";
import {DEFAULT_PER_PAGE} from "../../config";
import {StatusIndicator} from "../shared/Status";
import {DateTimeFormat} from "../shared/DateTimeFormat";
import {UnorderedListOutlined} from "@ant-design/icons";

class WebhooksLogModal extends React.Component
{
    state = {
        loading: false,
        loaded: false,
        pagination: { current: 1, pageSize: DEFAULT_PER_PAGE, total: 0, showSizeChanger: true },
        data: [],
        showDetails: false,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps !== prevState) {
            return nextProps;
        }

        return null;
    }

    componentDidUpdate(prevProps, prevState) {
        if(!this.state.loaded && this.props.showModal && !this.state.loading) {
            this.loadLogs();
        }
    }

    loadLogs(page = null, per_page = null) {
        if(page === null) {
            page = this.state.pagination.current;
        }

        if(per_page === null) {
            per_page = this.state.pagination.pageSize;
        }

        this.setState({ loading: true });

        this.props.loadCompanyWebhookLogs(this.props.companyGuid, this.props.webhookId, page, per_page, (res) => {
            this.setState({ data: res.data.data, loading: false, loaded: true, pagination: { current: res.data.page, pageSize: res.data.per_page, total: res.data.total, showSizeChanger: true }});
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loading: false, loaded: true });
                displayErrors(err.response.data);
            }
        });
    }

    closeModal() {
        this.setState({
            loading: false,
            loaded: false,
            pagination: { current: 1, pageSize: DEFAULT_PER_PAGE, total: 0, showSizeChanger: true },
            data: [],
        })

        this.props.close()
    }

    changePage(data) {
        this.loadWebhooks(data.current, data.pageSize);
    }

    render() {
        const columns = [
            { title: 'ID', dataIndex: 'guid', render: (item) => <code>{item}</code> },
            { title: 'Webhook', dataIndex: 'webhook' },
            { title: 'Event', render: (item, record) => record.message.event },
            { title: 'Status', dataIndex: 'status', render: (item) => <StatusIndicator status={item} />},
            { title: 'Created', dataIndex: 'date_created', render: (item) => <DateTimeFormat value={item} />},
            { title: 'Last Attempt', dataIndex: 'date_last_attempt', render: (item) => <DateTimeFormat value={item} />},
            { title: 'Attempts', dataIndex: 'attempt_count', align: 'center'},
            { title: 'Status', dataIndex: 'status_code', align: 'center' },
            { title: '', align: 'right', render: (item, record) => <Button icon={<UnorderedListOutlined />} size='small' onClick={() => this.setState({ showDetails: true, details: record.message.payload })}>Payload</Button> },
        ]

        return (
            <Modal
                centered
                title='Webhook Logs'
                open={this.props.showModal}
                width={'100%'}
                onCancel={() => this.closeModal()}
                footer={false}
                destroyOnClose={true}>
                <div style={{overflowX: 'auto'}}>
                    <Table
                        columns={columns}
                        size='small'
                        rowKey={(item) => item.guid}
                        dataSource={this.state.data}
                        loading={this.state.loading}
                        pagination={this.state.pagination}
                        onChange={(e) => this.changePage(e)}
                    />
                </div>

                <Modal
                    width={600}
                    title='Payload'
                    open={this.state.showDetails}
                    footer={false}
                    onCancel={() => this.setState({ showDetails: false, details: null})}>
                    <div style={{height: '500px', maxHeight: '500px', overflowY: 'scroll'}}>
                        <pre>
                        {JSON.stringify(this.state.details, null, 4)}
                    </pre>
                    </div>
                </Modal>
            </Modal>
        )
    }
}

export default connect(null, { loadCompanyWebhookLogs })(WebhooksLogModal);